export class extendModel {
  
    constructor(
      public mail: string,
      public passw: string,
      public order_id: string,
      public term_time: string,
      public local_term_time: string
    ) {  }
  
  }
  


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/extendModel.ts